import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import { MoreVert, Replay, Done, Phone } from "@material-ui/icons";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { Can } from "../Can";
import TicketOptionsMenu from "../TicketOptionsMenu";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import AcceptTicketWithouSelectQueue from "../AcceptTicketWithoutQueueModal";

const useStyles = makeStyles(theme => ({
	actionButtons: {
		marginRight: 6,
		flex: "none",
		alignSelf: "center",
		marginLeft: "auto",
		"& > *": {
			margin: theme.spacing(1),
		},
	},
}));

const TicketActionButtons = ({ ticket }) => {
	const classes = useStyles();
	const history = useHistory();
	const [anchorEl, setAnchorEl] = useState(null);
	const [loading, setLoading] = useState(false);
	const ticketOptionsMenuOpen = Boolean(anchorEl);
	const { user } = useContext(AuthContext);
	const [acceptTicketWithouSelectQueueOpen, setAcceptTicketWithouSelectQueueOpen] = useState(false);

	const handleOpenTicketOptionsMenu = e => {
		setAnchorEl(e.currentTarget);
	};

	const handleCloseTicketOptionsMenu = e => {
		setAnchorEl(null);
	};

	const handleUpdateTicketStatus = async (e, status, userId) => {
		setLoading(true);
		try {
			await api.put(`/tickets/${ticket.id}`, {
				status: status,
				userId: userId || null,
			});

			setLoading(false);
			if (status === "open") {
				history.push(`/tickets/${ticket.id}`);
			} else {
				history.push("/tickets");
			}
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
	};

	const handleOpenWavoipCall = () => {
		setLoading(true);

		try {
			if (!ticket.whatsapp.wavoip || !ticket.contact.number) {
				toastError("Erro: tokem ou número do telefone não disponível")
				setLoading(false);
				return;
			};
			const token= ticket.whatsapp.wavoip; 
			const phone = ticket.contact.number.replace(/\D/g, "");
			const name = ticket.contact.name;

			const url = `https://app.wavoip.com/call?token=${token}&phone=${phone}&name=${name}&start_if_ready=true&close_after_call=true`;

			window.open(url, "wavoip", "toolbar=no,scrollbars=no,resizable=no,top=500,left=500,width=500,height=700");
			setLoading(false);
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
	};

	const handleOpenAcceptTicketWithouSelectQueue = () => {
		setAcceptTicketWithouSelectQueueOpen(true);
	};

	return (
		<div className={classes.actionButtons}>
			<ButtonWithSpinner
				loading={loading}
				startIcon={<Phone color="secondary" />}
				size="small"
				onClick={handleOpenWavoipCall}
			>
				{i18n.t("messagesList.header.buttons.call")}
			</ButtonWithSpinner>
			<AcceptTicketWithouSelectQueue
				modalOpen={acceptTicketWithouSelectQueueOpen}
				onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
				ticketId={ticket.id}
			/>

			{ticket.status === "closed" && (
				<ButtonWithSpinner
					loading={loading}
					startIcon={<Replay />}
					size="small"
					onClick={e => handleUpdateTicketStatus(e, "open", user?.id)}
				>
					{i18n.t("messagesList.header.buttons.reopen")}
				</ButtonWithSpinner>
			)}
			{ticket.status === "open" && (
				<>
					<Can
						role={user.profile}
						perform="drawer-items:management"
						yes={() => (
							<ButtonWithSpinner
								loading={loading}
								startIcon={<Replay />}
								size="small"
								onClick={e => handleUpdateTicketStatus(e, "pending", null)}
							>
								{i18n.t("messagesList.header.buttons.return")}
							</ButtonWithSpinner>
						)}
					/>
					<ButtonWithSpinner
						loading={loading}
						size="small"
						variant="contained"
						color="primary"
						onClick={e => handleUpdateTicketStatus(e, "closed", user?.id)}
					>
						{i18n.t("messagesList.header.buttons.resolve")}
					</ButtonWithSpinner>
					<IconButton onClick={handleOpenTicketOptionsMenu}>
						<MoreVert />
					</IconButton>
					<TicketOptionsMenu
						ticket={ticket}
						anchorEl={anchorEl}
						menuOpen={ticketOptionsMenuOpen}
						handleClose={handleCloseTicketOptionsMenu}
					/>



				</>

			)}
			{(ticket.status === "pending" && (ticket.queue === null || ticket.queue === undefined)) && (
				<ButtonWithSpinner
					color="secondary"
					variant="contained"
					className={classes.acceptButton}
					size="small"
					loading={loading}
					onClick={e => handleOpenAcceptTicketWithouSelectQueue()}
				>
					<Done className={classes.bottomIcon} /> {i18n.t("ticketsList.buttons.acceptBeforeBot")}
				</ButtonWithSpinner>
			)}
			{(ticket.status === "pending" && ticket.queue !== null) && (
				<ButtonWithSpinner
					loading={loading}
					size="small"
					variant="contained"
					color="primary"
					onClick={e => handleUpdateTicketStatus(e, "open", user?.id)}
				>
					<Done className={classes.bottomIcon} /> {i18n.t("ticketsList.buttons.accept")}
				</ButtonWithSpinner>
			)}
			{ticket.status === "pending" && (
				<Can
					role={user.profile}
					perform="drawer-items:management"
					yes={() => (
						<ButtonWithSpinner
							loading={loading}
							size="small"
							variant="contained"
							color="primary"
							onClick={e => handleUpdateTicketStatus(e, "closed", user?.id)}
						>
							{i18n.t("messagesList.header.buttons.resolve")}
						</ButtonWithSpinner>
					)}
				/>
			)}
		</div>
	);
};

export default TicketActionButtons;
